import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NestedGridService {

  rowExapnderSubject$: Subject<any> = new Subject();
  gridHeightSubject$: Subject<any> = new Subject();
  gridSearchSubject$:Subject<any> = new Subject();
  summaryTabOpenSubject$:Subject<any> = new Subject();
  nodeDeregisterSubject$:Subject<any> = new Subject();
  gridResizeSubject$: Subject<any> = new Subject();
  recalculateGridSubject$: Subject<void> = new Subject();
  constructor() { }

  getGridRowExpandingSubscription() {
    return this.rowExapnderSubject$;
  }
  getGridheightSubscription() {
    return this.gridHeightSubject$;
  }
  notifyGridRowExpanding(value) {
    this.rowExapnderSubject$.next(value);
  }
  notifyRowHeight(value) {
    this.gridHeightSubject$.next(value);
  }
  getGridSearchSubscription(){
    return this.gridSearchSubject$;
  }
  
  notifyGridSearch(value) {
    this.gridSearchSubject$.next(value);
  }
  getSummaryTabOpenSubscription(){
    return this.summaryTabOpenSubject$;
  }
  notifySummaryTabOpen(value) {
    this.summaryTabOpenSubject$.next(value);
  }
  getNodeDeregisterSubscription(){
    return this.nodeDeregisterSubject$;
  }
  notifyNodeDeregister(value) {
    this.nodeDeregisterSubject$.next(value);
  }
  notifyGriResize(value) {
    this.gridResizeSubject$.next(value);
  }
  getGriResizeSubscription(){
    return this.gridResizeSubject$;
  }
  notifyRecalculateGrid() {
    this.recalculateGridSubject$.next();
  }
  getRecalculateGridSubscription(){
    return this.recalculateGridSubject$;
  }
}
